<sat-popover
	[anchor]="this.satAnchor$ | async"
	[hasBackdrop]="this.hasBackdrop"
	[id]="this.id"
	[interactiveClose]="true"
	[verticalAlign]="this.satLocation"
	*ngIf="!!this.satAnchor"
	class="menuWidth"
>
	<mat-card class="static-date-picker mat-elevation-z6 !p-0">
		<mat-card-content>
			<div class="flex flex-col">
				<mat-calendar
					(selectedChange)="changeSelectedDate($event)"
					[maxDate]="this.maxDate"
					[selected]="selectedDate$ | async"
					[startAt]="selectedDate$ | async"
					#appDate
				></mat-calendar>
			</div>
		</mat-card-content>
	</mat-card>
</sat-popover>
